// Отметка «вводные слайды этому посетителю уже показывали». Живет в
// localStorage, а не на сервере: слайды показываются ДО авторизации, когда
// пользователя еще некуда записать.
const INTRO_SLIDES_SHOWN_KEY = 'introSlidesShown';

const SHOWN_VALUE = '1';

/**
 * Показывали ли слайды раньше. Если localStorage недоступен (приватный режим,
 * запрет сторонних данных), считаем, что не показывали: лишний раз показать
 * питч безопаснее, чем не показать его вовсе тому, кто видит игру впервые.
 */
export const checkIfIntroSlidesShown = () => {
  try {
    return localStorage.getItem(INTRO_SLIDES_SHOWN_KEY) === SHOWN_VALUE;
  } catch (e) {
    return false;
  }
};

/**
 * Отметить факт показа. Ставится в момент, когда колода появилась на экране, а
 * не когда игрок долистал ее до конца: вход по Яндекс ID уводит со страницы, и
 * вернувшийся с неудачной авторизации человек не должен получить питч заново.
 */
export const markIntroSlidesShown = () => {
  try {
    localStorage.setItem(INTRO_SLIDES_SHOWN_KEY, SHOWN_VALUE);
  } catch (e) {
    // localStorage недоступен (приватный режим и т.п.) — просто не сохраняем
  }
};
